/* Klára Novotná: la barra fija de añadir al carrito muestra la talla y el color elegidos */
(function(){
  var busy=false;
  function selected(){
    var parts=[];
    document.querySelectorAll('.es-info .es-opt').forEach(function(f){
      var l=f.querySelector('.es-label'),val=f.querySelector('.es-opt-val');
      if(!l||!val)return;
      var n=l.firstChild?String(l.firstChild.textContent||'').replace(':','').trim():'';
      var t=val.textContent.trim();
      if(t)parts.push((n?n+': ':'')+t);
    });
    return parts.join(' · ');
  }
  function build(){
    busy=false;
    var bar=document.querySelector('.z-atc');
    if(!bar)return;
    var info=bar.querySelector('.z-atc__t');
    if(!info)return;
    var el=info.querySelector('.z-atc__sel');
    if(!el){
      el=document.createElement('em');
      el.className='z-atc__sel';
      var name=info.querySelector('span');
      if(name&&name.parentNode===info)info.insertBefore(el,name.nextSibling);else info.insertBefore(el,info.firstChild);
    }
    var s=selected();
    if(el.textContent!==s)el.textContent=s;
  }
  function later(){if(busy)return;busy=true;requestAnimationFrame(build)}
  document.addEventListener('change',function(){setTimeout(later,0);setTimeout(later,120);setTimeout(later,350)},true);
  document.addEventListener('click',function(){setTimeout(later,60)},true);
  function start(){
    build();
    [300,900,2000].forEach(function(ms){setTimeout(build,ms)});
    if(window.MutationObserver)new MutationObserver(later).observe(document.body,{childList:true,subtree:true,characterData:true});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
})();
